import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';

export function RouteErrorFallback() {
  const error = useRouteError();

  let title = 'Something went wrong';
  let message = 'An unexpected error occurred.';
  const showHomeLink = true;

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = 'Page Not Found';
      message = "The page you're looking for doesn't exist or has been moved.";
    } else if (error.status === 401) {
      title = 'Unauthorized';
      message = 'You need to be logged in to view this page.';
    } else if (error.status === 403) {
      title = 'Forbidden';
      message = "You don't have permission to access this page.";
    } else if (error.status >= 500) {
      title = 'Server Error';
      message = 'The server encountered an error. Please try again later.';
    }
  } else if (error instanceof Error) {
    message = error.message;
  }

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <div className="route-error-fallback">
      <div className="route-error-content">
        <AlertTriangle className="route-error-icon" aria-hidden="true" />
        <h1 className="route-error-title">{title}</h1>
        <p className="route-error-message">{message}</p>
        <div className="route-error-actions">
          <button onClick={handleRetry} className="btn btn-secondary">
            <RefreshCw className="icon icon-sm" aria-hidden="true" />
            Try Again
          </button>
          {showHomeLink && (
            <Link to="/" className="btn btn-primary">
              <Home className="icon icon-sm" aria-hidden="true" />
              Go Home
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
